import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

const ADD_CONDITION_VERSION_MUTATION = gql`
    mutation addConditionVersion($type: ConditionType!, $contentFr: String!, $contentEn: String!) {
        addConditionVersion(type: $type, contentFr: $contentFr, contentEn: $contentEn) {
            uuid
            versionNumber
            contentFr
            contentEn
            createdAt
        }
    }
`;

const useAddConditionVersion = () => {
    const [mutate, { loading, error }] = useMutation(ADD_CONDITION_VERSION_MUTATION);

    const addConditionVersion = async (type, contentFr, contentEn) => {
        return mutate({
            variables: {
                type,
                contentFr,
                contentEn,
            },
        });
    };

    return { addConditionVersion, loading, error };
};

export default useAddConditionVersion;
